module.exports = __webpack_public_path__ + "static/leader2-55171415c11af6deedcb04eaa65f7464.svg";